(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktopFilterQuery = window.matchMedia('(min-width: 940px)');
  var mobileFilterQuery = window.matchMedia('(max-width: 767.98px)');
  var revealObserver = null;

  if (!reducedMotion && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var index = Number(card.dataset.kbdRevealIndex || 0);
        card.style.transitionDelay = Math.min(index % 4, 3) * 70 + 'ms';
        card.classList.add('kbd-collection-reveal--visible');
        revealObserver.unobserve(card);
      });
    }, {
      rootMargin: '0px 0px 18% 0px',
      threshold: 0.01
    });
  }

  var observeCards = function (scope) {
    var cards = scope.querySelectorAll ? scope.querySelectorAll('[data-kbd-collection-reveal]:not([data-kbd-reveal-ready])') : [];
    Array.prototype.forEach.call(cards, function (card) {
      card.dataset.kbdRevealReady = 'true';
      if (reducedMotion || !revealObserver) {
        card.classList.add('kbd-collection-reveal--visible');
        return;
      }
      revealObserver.observe(card);
    });
  };

  var updateScrollableTitles = function (scope) {
    var titles = scope.querySelectorAll ? scope.querySelectorAll('[data-kbd-product-card] .product-block__title') : [];
    Array.prototype.forEach.call(titles, function (title) {
      var link = title.querySelector('.product-block__title-link');
      if (!link) return;

      title.classList.remove('product-block__title--marquee');
      title.style.removeProperty('--kbd-title-scroll-distance');
      title.style.removeProperty('--kbd-title-scroll-duration');

      var styles = window.getComputedStyle(title);
      var availableWidth = title.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
      var overflowDistance = Math.ceil(link.scrollWidth - availableWidth);
      if (overflowDistance <= 1) return;

      title.classList.add('product-block__title--marquee');
      title.style.setProperty('--kbd-title-scroll-distance', overflowDistance + 'px');
      title.style.setProperty('--kbd-title-scroll-duration', Math.max(2, Math.min(4, 1.5 + overflowDistance / 65)) + 's');
    });
  };

  var scheduleScrollableTitles = function (scope) {
    window.requestAnimationFrame(function () {
      updateScrollableTitles(scope || document);
    });
  };

  var setFilterSidebarState = function (button, collapsed) {
    var shell = button.closest('.collection-content-shell');
    if (!shell) return;

    shell.classList.toggle('kbd-filter-sidebar--collapsed', collapsed);
    button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    button.setAttribute('aria-label', collapsed ? button.dataset.expandLabel : button.dataset.collapseLabel);

    window.setTimeout(function () {
      scheduleScrollableTitles(shell);
    }, 240);
  };

  var initFilterSidebarToggles = function (scope) {
    var buttons = scope.querySelectorAll ? scope.querySelectorAll('.kbd-filter-sidebar-toggle:not([data-kbd-toggle-ready])') : [];
    Array.prototype.forEach.call(buttons, function (button) {
      button.dataset.kbdToggleReady = 'true';
      var initialShell = button.closest('.collection-content-shell');
      setFilterSidebarState(button, initialShell && initialShell.classList.contains('kbd-filter-sidebar--collapsed'));
      button.addEventListener('click', function () {
        var shell = button.closest('.collection-content-shell');
        setFilterSidebarState(button, !shell.classList.contains('kbd-filter-sidebar--collapsed'));
      });
    });
  };

  var syncFilterPanelsToBreakpoint = function () {
    var desktopSidebar = desktopFilterQuery.matches;

    document.querySelectorAll('[data-section-type="collection-template"]').forEach(function (section) {
      section.querySelectorAll('.cc-filter:not(.cc-filter--sort)').forEach(function (filter) {
        filter.open = desktopSidebar;
        filter.classList.toggle('is-open', desktopSidebar);
        if (desktopSidebar) filter.setAttribute('open', '');
        else filter.removeAttribute('open');
      });

      if (!desktopSidebar) {
        var filters = section.querySelector('.cc-filters');
        if (filters) filters.classList.remove('is-open');
      }
    });

    if (!desktopSidebar) document.body.classList.remove('filters-open');
  };

  var handleFilterBreakpointChange = function () {
    syncFilterPanelsToBreakpoint();
  };

  if (desktopFilterQuery.addEventListener) {
    desktopFilterQuery.addEventListener('change', handleFilterBreakpointChange);
    mobileFilterQuery.addEventListener('change', handleFilterBreakpointChange);
  } else {
    desktopFilterQuery.addListener(handleFilterBreakpointChange);
    mobileFilterQuery.addListener(handleFilterBreakpointChange);
  }

  var initCollectionReveal = function () {
    observeCards(document);
    scheduleScrollableTitles(document);
    initFilterSidebarToggles(document);
    syncFilterPanelsToBreakpoint();
    if (!document.body || document.body.dataset.kbdCollectionObserver === 'true') return;
    document.body.dataset.kbdCollectionObserver = 'true';
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-kbd-collection-reveal]')) observeCards(node.parentElement || document);
          else observeCards(node);
          scheduleScrollableTitles(node.parentElement || document);
          initFilterSidebarToggles(node.parentElement || document);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  // The app injects these controls asynchronously. On touch devices, keep a
  // control tap from bubbling into the product-card links underneath it.
  document.addEventListener('click', function (event) {
    var control = event.target.closest && event.target.closest('.kbd-ni-heart, .kbd-ni-bell, .kbd-ni-card-actions');
    if (!control || !control.closest('[data-kbd-product-card]')) return;
    event.preventDefault();
    event.stopPropagation();
  });

  document.addEventListener('click', function (event) {
    if (!window.matchMedia('(max-width: 767.98px)').matches) return;

    var collectionSection = event.target.closest && event.target.closest('[data-section-type="collection-template"]');
    if (!collectionSection) return;

    var showFilters = event.target.closest('.js-show-filters');
    if (showFilters) {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.body.classList.add('filters-open');

      var filters = collectionSection.querySelector('.cc-filters');
      if (filters) filters.classList.add('is-open');

      collectionSection.querySelectorAll('.cc-filter:not(.cc-filter--sort)').forEach(function (filter) {
        filter.open = true;
        filter.classList.add('is-open');
      });

      var filterItems = collectionSection.querySelector('.cc-filters__items');
      if (filterItems) filterItems.scrollTop = 0;
      return;
    }

    var filterToggle = event.target.closest('.cc-filter:not(.cc-filter--sort) > .cc-filter__toggle');
    if (!filterToggle) return;

    var filter = filterToggle.closest('.cc-filter');
    event.preventDefault();
    event.stopImmediatePropagation();
    var shouldOpen = !filter.open || !filter.classList.contains('is-open');
    filter.open = shouldOpen;
    filter.classList.toggle('is-open', shouldOpen);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollectionReveal);
  else initCollectionReveal();

  document.addEventListener('shopify:section:load', function (event) {
    observeCards(event.target);
    scheduleScrollableTitles(event.target);
    initFilterSidebarToggles(event.target);
  });

  document.addEventListener('filters-applied', function () {
    scheduleScrollableTitles(document);
    if (!desktopFilterQuery.matches) syncFilterPanelsToBreakpoint();
  });

  window.addEventListener('resize', function () {
    scheduleScrollableTitles(document);
  });
})();
